import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #0a0b14;
  padding: 20px;
`;

const PaymentCard = styled.div`
  max-width: 500px;
  width: 100%;
  background-color: #171923;
  border-radius: 12px;
  padding: 40px 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  text-align: center;
`;

const IconContainer = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #F44336;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 24px;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 400;
  margin-bottom: 16px;
  color: #fff;
`;

const Message = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #e1e1e1;
  margin-bottom: 40px;
`;

const Button = styled.button`
  display: block;
  width: 100%;
  padding: 14px;
  margin-bottom: 16px;
  border-radius: 50px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &.primary {
    background-color: #A961ED;
    color: white;
    
    &:hover {
      background-color: #9050c9;
    }
  }
  
  &.secondary {
    background-color: transparent;
    color: white;
    border: 1px solid #2d3748;
    
    &:hover {
      background-color: rgba(45, 55, 72, 0.5);
    }
  }
`;

const PaymentFailed = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Parse query parameters to get error details
  const params = new URLSearchParams(location.search);
  const errorMessage = params.get('message') || 'We were unable to process your payment';

  return (
    <PageContainer>
      <PaymentCard>
        <IconContainer>
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" color="white">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </IconContainer>

        <Title>Payment Failed</Title>

        <Message>
          We were unable to process your payment. Please try again
          or contact support if the problem persists.
        </Message>

        <Button
          className="primary"
          onClick={() => navigate('/checkout')}
        >
          Try Again
        </Button>

        <Button
          className="secondary"
          onClick={() => navigate('/contact')}
        >
          Contact Support
        </Button>
      </PaymentCard>
    </PageContainer>
  );
};

export default PaymentFailed; 